export const BUTTON_SOURCES = {
  WELCOME_SCREEN: 'welcome-screen',
  MAIN_SCREEN: 'main-screen',
  SUMMARY_SCREEN: 'summary-screen',
  SPLIT_BILL_SHEET: 'split-bill-sheet',
  SPLIT_EQUALLY: 'split-equally',
  SPLIT_CUSTOM: 'split-custom',
  SPLIT_ITEMS: 'split-items',
  NO_BILL: 'no-bill',
  CASHBACK_BANNER: 'cashback-banner',
  ORDER_PROMPT_MODAL: 'order-prompt-modal',
  MENU_ITEM_CARD: 'menu-item-card',
} as const;

export type ButtonSource = (typeof BUTTON_SOURCES)[keyof typeof BUTTON_SOURCES];
